import React from 'react';

import RegularRate from '../../rates/RegularRate.jsx';
import SlotName from '../SlotName.jsx';

export default class MatchCorrectScoreOutcomeSlot extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        match: React.PropTypes.object,
        outcomes: React.PropTypes.array.isRequired,
        sportId: React.PropTypes.number.isRequired,
        slot: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps) {
        return this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId ||
            this.props.slot !== nextProps.slot ||
            this.props.outcomes !== nextProps.outcomes;
    }

    render() {
        const {section, sportId, slot, outcomes, match, gridLocalization} = this.props;

        const outcome = outcomes[0];

        const outcomeRates = {};

        outcome.get('rates')
            .entrySeq()
            .sortBy((r) => r[0])
            .forEach((r) => {
                outcomeRates[r[0]] = r[1];
            });

        const slotNameProps = {
            sportId,
            match,
            slot,
            outcome,
            gridLocalization
        };

        const props = {
            section,
            gridLocalization
        };

        return (
            <div className="table detailed">
                <div className="row inner">
                    <div className="cell main">
                        <SlotName {...slotNameProps}/>
                    </div>

                    <div className="cell rate ss">
                        <div className="correct-score cf">
                            <RegularRate key={outcomeRates[8]} id={outcomeRates[8]}
                                {...props} />
                            <RegularRate key={outcomeRates[15]} id={outcomeRates[15]}
                                {...props} />
                            <RegularRate key={outcomeRates[16]} id={outcomeRates[16]}
                                {...props} />
                            <RegularRate key={outcomeRates[20]} id={outcomeRates[20]}
                                {...props} />
                            <RegularRate key={outcomeRates[21]} id={outcomeRates[21]}
                                {...props} />
                            <RegularRate key={outcomeRates[22]} id={outcomeRates[22]}
                                {...props} />
                            <RegularRate key={outcomeRates[24]} id={outcomeRates[24]}
                                {...props} />
                            <RegularRate key={outcomeRates[25]} id={outcomeRates[25]}
                                {...props} />
                            <RegularRate key={outcomeRates[26]} id={outcomeRates[26]}
                                {...props} />
                            <RegularRate key={outcomeRates[27]} id={outcomeRates[27]}
                                {...props} />
                            <RegularRate key={outcomeRates[28]} id={outcomeRates[28]}
                                {...props} />
                            <RegularRate key={outcomeRates[29]} id={outcomeRates[29]}
                                {...props} />
                            <RegularRate key={outcomeRates[30]} id={outcomeRates[30]}
                                {...props} />
                        </div>

                        <div className="correct-score cf">
                            <RegularRate key={outcomeRates[1]} id={outcomeRates[1]}
                                {...props} />
                            <RegularRate key={outcomeRates[9]} id={outcomeRates[9]}
                                {...props} />
                            <RegularRate key={outcomeRates[17]} id={outcomeRates[17]}
                                {...props} />
                            <RegularRate key={outcomeRates[23]} id={outcomeRates[23]}
                                {...props} />
                        </div>

                        <div className="correct-score cf">
                            <RegularRate key={outcomeRates[2]} id={outcomeRates[2]}
                                {...props} />
                            <RegularRate key={outcomeRates[3]} id={outcomeRates[3]}
                                {...props} />
                            <RegularRate key={outcomeRates[10]} id={outcomeRates[10]}
                                {...props} />
                            <RegularRate key={outcomeRates[4]} id={outcomeRates[4]}
                                {...props} />
                            <RegularRate key={outcomeRates[11]} id={outcomeRates[11]}
                                {...props} />
                            <RegularRate key={outcomeRates[18]} id={outcomeRates[18]}
                                {...props} />
                            <RegularRate key={outcomeRates[5]} id={outcomeRates[5]}
                                {...props} />
                            <RegularRate key={outcomeRates[12]} id={outcomeRates[12]}
                                {...props} />
                            <RegularRate key={outcomeRates[19]} id={outcomeRates[19]}
                                {...props} />
                            <RegularRate key={outcomeRates[6]} id={outcomeRates[6]}
                                {...props} />
                            <RegularRate key={outcomeRates[13]} id={outcomeRates[13]}
                                {...props} />
                            <RegularRate key={outcomeRates[7]} id={outcomeRates[7]}
                                {...props} />
                            <RegularRate key={outcomeRates[14]} id={outcomeRates[14]}
                                {...props} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/slots/soccer/MatchCorrectScoreOutcomeSlot.jsx